module.exports = __webpack_public_path__ + "static/media/coordenadas-gris.3543cd72.svg";